// Auth
export const POST_LOGIN = "/admin/login";
export const POST_REGISTER = "/admin/register";

// Wheel
export const GET_WHEEL_PROPERTIES = "/gann-wheel/";
export const POST_WHEEL_PROPERTIES = "/gann-wheel/admin";
// export const GET_ASTROLOGY = "/gann-wheel/western_horoscope";
export const GET_ASTROLOGY = "/gann-wheel/western_horoscope_new";

export const USERS_LISTING = "/user/admin/users";

// subscription plans
export const PLANS_LISTING = "/admin/plans/list";
export const PLAN_ADD = "/admin/plans";
export const PLAN_EDIT = "/admin/plans";
export const PLAN_DELETE = "/admin/plans";

// stocks
export const STOCKS_LISTING = "/admin/stock-exchange";
export const STOCK_ADD = "/admin/stock-exchange";
export const STOCK_EDIT = "/admin/stock-exchange";

// utility
export const UTILITY_USERS_LISTING = "/admin/utility/users";
export const UTILITY_PLANS_LISTING = "/admin/utility/plans";
export const UTILITY_STOCKS_LISTING = "/admin/utility/stocks";